export default {
  resource_center_title: 'Centre de ressources',
  resource_center_empty: 'Aucune ressource d’aide n’est disponible.',
  resource_center_new_tab: '(s’ouvre dans un nouvel onglet)',
  configure_resource_center_description_part1:
    'Gérez les liens d’aide affichés dans le Centre de ressources. Un lien s’affiche pour tout utilisateur détenant ',
  configure_resource_center_description_emphasis: 'au moins l’une',
  configure_resource_center_description_part2:
    ' des autorisations requises. Réorganisez par glisser-déposer, ou ciblez une poignée de déplacement, appuyez sur la barre d’espace pour la saisir, puis utilisez les touches fléchées.',
  configure_resource_center_add_link: '+ Ajouter un lien',
  configure_resource_center_form_title_add: 'Ajouter un lien',
  configure_resource_center_form_title_edit: 'Modifier le lien',
  configure_resource_center_url_label: 'URL',
  configure_resource_center_url_required: 'L’URL est requise',
  configure_resource_center_url_invalid: 'L’URL doit être une URL valide',
  configure_resource_center_label: '{{language}} Libellé',
  configure_resource_center_label_required: 'Le nom du lien est requis',
  configure_resource_center_subheading_label:
    '{{language}} Sous-titre (facultatif)',
  configure_resource_center_products_title:
    'Produits: (l’utilisateur doit en avoir au moins un pour voir le lien)',
  configure_resource_center_products_label: 'Produits',
  configure_resource_center_cancel: 'Annuler',
  configure_resource_center_save_changes: 'Enregistrer les modifications',
  configure_resource_center_toast_changes_saved:
    'Modifications enregistrées avec succès',
  configure_resource_center_toast_link_added: 'Lien ajouté avec succès',
  configure_resource_center_edit: 'Modifier',
  configure_resource_center_delete: 'Supprimer',
  configure_resource_center_undo_message: '« {{label}} » a été supprimé',
  configure_resource_center_undo: 'Annuler la suppression',
  configure_resource_center_undo_error:
    'Impossible de restaurer le lien. Veuillez réessayer.',
  configure_resource_center_delete_error:
    'Impossible de supprimer le lien. Veuillez réessayer.'
};
